/* src/app/components/lead-details/participant-sick-time/participant-sick-time.component.css */
.ant-picker-range {
  height: 32px !important;
}
/*# sourceMappingURL=participant-sick-time.component-2EI7SNH3.css.map */
